import React, { useCallback, useState, createContext, useContext } from 'react';
import { Lang, translations } from './i18n';
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: typeof translations.en;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
function detectLang(): Lang {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    if (path.startsWith('/en')) return 'en';
    // /id prefix or root → Indonesian
    return 'id';
  }
  return 'id';
}
interface LanguageProviderProps {
  children: React.ReactNode;
}
export function LanguageProvider({
  children
}: LanguageProviderProps) {
  const [lang, setLangState] = useState<Lang>(detectLang);
  const setLang = useCallback((newLang: Lang) => {
    setLangState(newLang);
    document.documentElement.lang = newLang;
    // Strip existing /en or /id prefix, then apply new one
    const currentPath = window.location.pathname;
    const pathWithoutLang = currentPath.startsWith('/en') ? currentPath.slice(3) || '/' : currentPath.startsWith('/id') ? currentPath.slice(3) || '/' : currentPath;
    const newPath = `/${newLang}${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    window.history.pushState({}, '', newPath);
  }, []);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-359">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}